"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _auth = require("@/utils/auth");

var _v = _interopRequireDefault(require("uuid/v4"));

var _constants = require("@/utils/constants");

var _button_widget = _interopRequireDefault(require("@/views/widgets/button_widget.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import draggable from 'vuedraggable'
var _default = {
  components: {
    Button: _button_widget.default
  },
  data: function data() {
    var validateMaxLength = function validateMaxLength(rule, value, callback) {
      if (value.trim() === '' || value === null) {
        callback(new Error(rule.colname + 'を入力してください。'));
      } else if (value.length > rule.maxLen) {
        callback(new Error(rule.maxLen + '文字以下で入力してください。'));
      } else {
        callback();
      }
    };

    return {
      category_key: '',
      role: {},
      enableDialogVisible: false,
      enableCreate: false,
      editValueInfo: {},
      disableButton: true,
      categoryId: null,
      form: {
        titleDialog: '',
        inputDialog: ''
      },
      validateMaxLength: function validateMaxLength(rule, value, callback) {
        if (value.trim() === '' || value === null) {
          callback(new Error(rule.colname + 'を入力してください。'));
        } else if (value.length > rule.maxLen) {
          callback(new Error(rule.maxLen + '文字以下で入力してください。'));
        } else {
          callback();
        }
      },
      rules: {
        inputDialog: [{
          required: false,
          validator: validateMaxLength,
          colname: 'カテゴリー名',
          maxLen: 20
        }]
      }
    };
  },
  computed: {
    suggestionCategories: function suggestionCategories() {
      return this.$store.getters.suggestionCategories;
    }
  },
  watch: {
    $data: {
      deep: true,
      handler: function handler(value) {
        this.listeningStatusUpdateButton(value);
      }
    }
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var roleType;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.$store.commit('suggestion/SET_SHOW_ALL_ITEM', false);

            case 2:
              _context.next = 4;
              return this.$store.dispatch('suggestion/getSuggestionCategories');

            case 4:
              _context.next = 6;
              return (0, _auth.getUserPermission)();

            case 6:
              roleType = _context.sent;

              if (roleType) {
                this.role = JSON.parse(roleType);
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    listeningStatusUpdateButton: function () {
      var _listeningStatusUpdateButton = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(value) {
        var isHistory, isChanged;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _auth.getHistoryDataFromPage)();

              case 2:
                isHistory = _context2.sent;
                isChanged = JSON.stringify("".concat(value.form.inputDialog));

                if (isHistory !== isChanged && this.form.inputDialog) {
                  this.disableButton = false;
                } else {
                  this.disableButton = true;
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function listeningStatusUpdateButton(_x) {
        return _listeningStatusUpdateButton.apply(this, arguments);
      }

      return listeningStatusUpdateButton;
    }(),
    handleOpenDialog: function handleOpenDialog(createEnable, editInfo) {
      this.category_key = (0, _v.default)();
      this.enableDialogVisible = true;

      if (createEnable) {
        this.enableCreate = true;
        this.form.titleDialog = 'カテゴリー追加';
      } else {
        this.enableCreate = false;
        this.form.titleDialog = 'カテゴリー編集';
      }

      if (editInfo) {
        this.form.inputDialog = editInfo.name;
        this.editValueInfo = editInfo;
        this.categoryId = editInfo.id;
      } else {
        this.form.inputDialog = '';
      }

      (0, _auth.setHistoryDataFromPage)(JSON.stringify("".concat(this.form.inputDialog)));
    },
    handleDialogValidate: function handleDialogValidate() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this.enableDialogVisible = false;

          _this.handleOnConfirm();
        } else {
          _this.log('error submit!!');

          return false;
        }
      });
    },
    handleOnConfirm: function () {
      var _handleOnConfirm = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        var valInput, result, _result;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                valInput = this.form.inputDialog;

                if (valInput) {
                  valInput.trim();
                }

                if (!this.enableCreate) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 5;
                return this.$store.dispatch('suggestion/insertSuggestionCategories', valInput).catch(function (error) {
                  _this2.$notify({
                    title: 'エラー',
                    message: 'カテゴリーの追加に失敗しました。',
                    type: 'error',
                    duration: 10000,
                    showClose: true
                  });

                  console.log(error);
                  throw error;
                });

              case 5:
                result = _context3.sent;

                if (!result) {
                  _context3.next = 10;
                  break;
                }

                this.$notify({
                  title: '情報',
                  message: 'カテゴリーの追加が完了しました。',
                  type: 'success',
                  duration: 2000
                });
                _context3.next = 10;
                return this.$store.dispatch('suggestion/getSuggestionCategories');

              case 10:
                _context3.next = 19;
                break;

              case 12:
                _context3.next = 14;
                return this.$store.dispatch('suggestion/updateSuggestionCategories', {
                  id: this.editValueInfo.id,
                  name: valInput
                }).catch(function (error) {
                  _this2.$notify({
                    title: 'エラー',
                    message: 'カテゴリーの更新に失敗しました。',
                    type: 'error',
                    duration: 10000,
                    showClose: true
                  });

                  console.log(error);
                  throw error;
                });

              case 14:
                _result = _context3.sent;

                if (!_result) {
                  _context3.next = 19;
                  break;
                }

                this.$notify({
                  title: '情報',
                  message: 'カテゴリーの更新が完了しました。',
                  type: 'success',
                  duration: 2000
                });
                _context3.next = 19;
                return this.$store.dispatch('suggestion/getSuggestionCategories');

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function handleOnConfirm() {
        return _handleOnConfirm.apply(this, arguments);
      }

      return handleOnConfirm;
    }(),
    handleDeleteItem: function () {
      var _handleDeleteItem = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var _this3 = this;

        var questionYesOrNo, result;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return (0, _constants.message_box_confirm)('確認', 'このカテゴリーを削除するとすべての所属している目安箱はカテゴリーが無くなります。よろしいですか？', '削除', 'message_delete');

              case 2:
                questionYesOrNo = _context4.sent;

                if (!questionYesOrNo) {
                  _context4.next = 12;
                  break;
                }

                _context4.next = 6;
                return this.$store.dispatch('suggestion/deleteCategoryAndUpdateSuggestionCategoryById', this.categoryId).catch(function (error) {
                  _this3.$notify({
                    title: 'エラー',
                    message: 'カテゴリーの削除に失敗しました。',
                    type: 'error',
                    duration: 10000,
                    showClose: true
                  });

                  console.log(error);
                  throw error;
                });

              case 6:
                result = _context4.sent;

                if (!result) {
                  _context4.next = 11;
                  break;
                }

                this.$notify({
                  title: '情報',
                  message: 'カテゴリーの削除が完了しました。',
                  type: 'success',
                  duration: 2000
                });
                _context4.next = 11;
                return this.$store.dispatch('suggestion/getSuggestionCategories');

              case 11:
                this.enableDialogVisible = false;

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleDeleteItem() {
        return _handleDeleteItem.apply(this, arguments);
      }

      return handleDeleteItem;
    }()
  }
};
exports.default = _default;